import { Link } from 'react-router-dom';
import {
  Card,
  CardFooter,
  CardHeader,
  CardContent,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import AgentCarousel from './agentCarousel';
import { useAiChats } from '@Hooks/useAiChats';
import { MessageSquare } from 'lucide-react';
import { formatDate } from '@Utils/utils';

export default function TopRow({ setCurrentAgent }) {
  const { data: chats, status: chatsStatus } = useAiChats({ limit: 2 });

  const renderChatCards = () => {
    if (chatsStatus !== 'success') {
      return (
        <Card className="col-span-1 flex h-75 items-center justify-center">
          <div className="h-6 w-6 animate-spin rounded-full border-5 border-zinc-200 border-t-[#CAAB6A]" />
        </Card>
      );
    }

    if (chats?.length === 0) {
      return (
        <Card className="col-span-1 flex h-75 flex-col items-center justify-center gap-4">
          <p className="text-sm text-zinc-500">Start a new chat.</p>
          <Button asChild variant="secondary">
            <Link to="/ai-chat">Start chat</Link>
          </Button>
        </Card>
      );
    }

    return chats.map((item) => {
      const itemColor = '#CAAB6A';
      return (
        <Card
          key={item.id}
          className="h-75 justify-between gap-2 border-t-40 pt-0"
          style={{ borderTopColor: itemColor }}
        >
          <div className="flex flex-col">
            <div className="flex w-full justify-end pr-4">
              <div className="-mt-5 rounded-3xl bg-white p-4">
                <MessageSquare className="h-4 w-4" />
              </div>
            </div>
            <CardHeader className="pb-2">
              <Heading level="h3" className="text-ellipsis">
                {item.title}
              </Heading>
            </CardHeader>
            <CardContent className="flex flex-col gap-1">
              <p className="text-sm">Agent: {item.soul?.name}</p>
              <p className="text-sm">Created: {formatDate(item.createdAt)}</p>
            </CardContent>
          </div>
          <CardFooter>
            <Button asChild variant="secondary">
              <Link to="/ai-chat" state={{ chatId: item.id }}>
                Continue Chat
              </Link>
            </Button>
          </CardFooter>
        </Card>
      );
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full justify-center">
        <span className="text-3xl">Ai Agents</span>
      </div>

      <div className="grid grid-cols-4 gap-6">
        <AgentCarousel setCurrentAgent={setCurrentAgent} />
        {renderChatCards()}
      </div>
    </div>
  );
}
